import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { knowledgeManagementTagsInterface } from 'src/app/util/interfaces/knowledgeManagementTags';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class KnowledgeManagementTagsService {
	knowledgeTagUrl = environment.baseApiUrl + 'kb/tags';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	getTags(customerList: string, parent_id?: number, depth?: number): Observable<knowledgeManagementTagsInterface[]> {
		const parameters = {
			idParent: '',
			depth: '',
			customerList: customerList,
		};
		if (parent_id != undefined) parameters.idParent = parent_id.toString();
		if (depth != undefined) parameters.depth = depth.toString();
		return this.http.get<knowledgeManagementTagsInterface[]>(this.knowledgeTagUrl, { headers: this.headers, params: parameters });
	}

	addTag(newTag: knowledgeManagementTagsInterface): Observable<any> {
		return this.http.post(this.knowledgeTagUrl, newTag, { headers: this.headers });
	}

	updateTag(tag: knowledgeManagementTagsInterface): Observable<any> {
		return this.http.put(this.knowledgeTagUrl, tag, { headers: this.headers });
	}

	deleteTag(idTag: string): Observable<any> {
		return this.http.delete(this.knowledgeTagUrl, { headers: this.headers, params: { id: idTag } });
	}
}
